module.exports = window["nab"]["codeEditor"];